import {Component, OnInit} from '@angular/core';
import {OAClient} from '../../../../models/oaclient';
import Commons from "../../commons";
import {AuthRESTService} from '../../../services/rest/auth-rest.service';
import _ from 'lodash';
import {ActivatedRoute} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {Router} from '@angular/router';
import {DragulaService, DragulaModule} from "ng2-dragula";
import { MetaPropertySchema } from '../../../../models/metaPropertySchema';
import { SharedModule } from 'app/shared.module';
import { AppWidgetModule } from 'app/components/widgets/widget.module';

@Component({
  standalone: true,
  imports: [SharedModule, AppWidgetModule, DragulaModule],
  templateUrl: './registration-form-fields-list.component.html',
	styleUrls: ['./registration-form-fields-list.component.css'],
	providers: [DragulaService],
})
export class RegistrationFormFieldsList extends Commons implements OnInit {
	propertyList: any [];
	reservedPropertyNames: string[] = ["name"];
	errorMessage;
	propertiesToDelete: string;

	constructor(private router: Router, private route: ActivatedRoute, private rest: AuthRESTService,
		toastr: ToastrService, translate: TranslateService, private dragulaService: DragulaService) {
		super(toastr, translate);
		dragulaService.dropModel().subscribe((value) => {
			if (!this.propertyList.length) return;
			// const [bagName, dropped, target, source, siblingAfter] = value;
			const { el, sibling } = value;
      const dropped =  el as HTMLTableRowElement;
      const siblingAfter = sibling as HTMLTableRowElement;
			let oldIndex = this.propertyList.findIndex((prop) => { return parseInt(dropped.dataset.id) === prop.id });
			let droppedProp = this.propertyList.splice(oldIndex, 1)[0];
			let newIndex;
			if (siblingAfter && siblingAfter.dataset.id) {
				newIndex = this.propertyList.findIndex((prop) => { return parseInt(siblingAfter.dataset.id) === prop.id });
			} else {
				newIndex = this.propertyList.length;
			}
			this.propertyList.splice(newIndex, 0, droppedProp);
			this.save()
		});
	}

	getData(cb?) {
		this.route.params.subscribe(params => {
            this.rest.get('property').subscribe((response) => {
				this.propertyList = response.sort((a, b) => { return a.ordering - b.ordering; }).map((prop) => {
					prop.display = JSON.parse(prop.display);
					return prop;
				});
				if (cb && typeof cb === "function") {
					cb();
				}
            }, err => this.errorHandler(err))
        });
	}

    ngOnInit() {
		this.getData()
	}

	addProperty(): void {
		this.clearNotifications();
		this.rest.put('property', {
			name: "new_property_" + new Date().getTime(),
			usedOnForm: false,
			requiredOnForm: false,
			display: JSON.stringify((new MetaPropertySchema().display))
		}).subscribe((response) => {
			this.addSuccess('general.save');
			this.getData(() => {
				this.router.navigate(['/configure-registration-form/' + response.id + '/edit'])
			});
        }, err => this.errorHandler(err))
	}

	deleteProperty(id): void {
		this.clearNotifications();
		this.rest.delete('property/' + id).subscribe((response) => {
			this.propertyList.splice(this.propertyList.findIndex((prop) => {
				return prop.id === id;
			}), 1);
			this.addSuccess('general.saved');
        }, err => this.errorHandler(err))
	}

	getFieldDisplayedName(formProperty) {
		return (formProperty.display && formProperty.display.placeholder && formProperty.display.placeholder[this.translate.currentLang]) ||
			(formProperty.name);
	}

    save(): void {
		this.clearNotifications();
		let ordering = 0;
		this.propertyList.forEach((prop) => {
			prop.ordering = ordering;
			ordering++;
		});

		this.rest.post('property/list', this.propertyList.map((prop) => {
			var saveItem = Object.assign({}, prop);
			saveItem.display = JSON.stringify(saveItem.display);
			return saveItem;
		})).subscribe((response) => {
			this.addSuccess('general.saved');
        }, err => this.errorHandler(err))
    }

}
